<template>
  <v-footer
    absolute
    id="dashboard-core-footer"
  >
    <v-container>
      <v-row
        align="center"
        justify="center"
        no-gutters
      >
        <v-col
          cols="12"
          md="auto"
        >
          <div class="body-2 font-weight-light pt-6 pt-md-0 text-center">
            <span style="color:white;">Badan Pengelola Dana Perkebunan &copy; 2026, </span><a href="https://www.bpdp.or.id">v{{ appVersion }}</a>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
  export default {
    name: 'DashboardCoreFooter',

    data: () => ({
    }),
    computed: {
    currentYear() {
      return new Date().getFullYear();
    },
    appVersion() {
      return localStorage.getItem('currVersion')
        ? localStorage.getItem('currVersion')
        : 2;
    }
  }
  }
</script>

<style lang="sass">
  #dashboard-core-footer
    a
      font-size: .825rem
      font-weight: 500
      text-decoration: none
      text-transform: uppercase
</style>
